import Header from "./components/header/Header";
import Footer from "./components/Footer";
import {Box} from "@mui/material";
import {Outlet} from "react-router";
import BackgroundGradient from "./GradientBackground";

const Layout = () => (
    <Box sx={{minHeight: "100dvh", display: "flex", flexDirection: "column"}}>
        <BackgroundGradient/>
        <Header/>
        <Box sx={{flexGrow: 1}}>
            <Outlet/>
        </Box>
        <Footer/>
    </Box>
);

export default Layout